import React from 'react';

const PolicyPerformanceIcon = () => {
  return (
    <svg width="18px" height="21px" viewBox="0 0 18 21" version="1.1">
      <title>E84AF509-58C0-4412-A319-E6A28E371ACA</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="Full-Prototype-Spec"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Step-1---Risk-Profile"
          transform="translate(-27.000000, -306.000000)"
        >
          <g id="Sidebar">
            <g id="Menu-Icons" transform="translate(24.000000, 58.000000)">
              <g id="Icon-ArrowUp" transform="translate(3.000000, 248.000000)">
                <path
                  d="M16.2800012,3.00001423 L14.9609924,3.00001423 C14.9335045,3.00001423 14.9090735,3.00933281 14.8835129,3.01543607 L14.8835129,1.64810625 C14.8835129,0.739265625 14.1174953,0 13.1757445,0 L1.73414302,0 C0.792393037,0 0.0263754895,0.739265625 0.0263754895,1.64810625 L0.0263754895,17.018564 C0.0263754895,17.9274041 0.792393037,18.6666704 1.73414335,18.6666704 L3.74066018,18.6666704 L3.74066018,19.4108246 C3.74066018,20.2871157 4.47732778,21 5.3831473,21 L16.2800018,21 C17.1858213,21 17.9224883,20.2871157 17.9224883,19.4108248 L17.9224883,4.58918913 C17.9224877,3.71289854 17.1858207,3.00001423 16.2800012,3.00001423 Z M0.701684765,17.0185642 L0.701684765,1.64810625 C0.701684765,1.10709378 1.16499808,0.666684408 1.73414335,0.666684408 L13.1757449,0.666684408 C13.7448911,0.666684408 14.2082038,1.10709378 14.2082038,1.64810625 L14.2082038,17.018564 C14.2082038,17.5595765 13.7448911,18.0000188 13.1757449,18.0000188 L1.73414335,18.0000188 C1.16499808,18.0000189 0.701684765,17.5595766 0.701684765,17.0185642 Z M17.2471453,19.4108248 C17.2471453,19.9196161 16.8132149,20.3333484 16.2800012,20.3333484 L5.3831467,20.3333484 C4.84993236,20.3333484 4.41596899,19.919616 4.41596899,19.4108248 L4.41596899,18.6666705 L13.1757439,18.6666705 C14.1174947,18.6666705 14.8835122,17.9274042 14.8835122,17.0185642 L14.8835122,3.65124365 C14.9090729,3.65734694 14.9335038,3.66666549 14.9609918,3.66666549 L16.2800006,3.66666549 C16.8132143,3.66666549 17.2471447,4.08039847 17.2471447,4.5891891 L17.2471447,19.4108248 L17.2471453,19.4108248 Z"
                  id="Shape"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                ></path>
                <polygon
                  id="Shape"
                  fill="#B9B9B9"
                  transform="translate(6.500000, 10.500000) scale(-1, 1) translate(-6.500000, -10.500000) "
                  points="11.9888889 7 6.5 12.32 2.45555556 8.4 5.77777778 8.4 5.77777778 7 0 7 0 12.6 1.44444444 12.6 1.44444444 9.38 6.5 14.28 13 7.98"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PolicyPerformanceIcon;
